import React from 'react'
import styled from "styled-components"

const Div = styled.div`
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(186,186,186,1);
  padding: ${props => props.padding};
  width: ${props => props.width};
  height: ${props => props.height};
  text-align: ${props => props.textAlign};
  display: inline-block;
  margin: ${props => props.margin};
  box-sizing: border-box;
`

const DivWhite = ({content = "", children, padding = "auto", width = "auto", height = "auto", textAlign = "left", margin = "0", onClick = null}) => {
    return <Div width={width} height={height} padding={padding}
                textAlign={textAlign} margin={margin} onClick={onClick}>{content}{children}</Div>
}

export default DivWhite
